import { FC, ReactNode } from 'react'

interface Props {
  children: ReactNode
  className?: string
}

const Panel: FC<Props> = ({ children, className = '' }) => (
  <div className={`bg-white rounded-2xl shadow-[0_2px_8px_-2px_rgba(21,25,48,0.06)] p-6 ${className}`}>
    {children}
  </div>
)

export default Panel
